
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.562 25.905l-9.423-9.423a1.505 1.505 0 00-2.121 0l-.707.707-5.75-5.75L23 2H13L8.561 6.439 8.122 6H6.001v2.121l.439.439-6.439 6.439 5 5 6.439-6.439 5.75 5.75-.707.707a1.505 1.505 0 000 2.121l9.423 9.423a1.505 1.505 0 002.121 0l3.535-3.535a1.505 1.505 0 000-2.121z"}})])
          )
        }
      }
    